import { baseUrl, campaignUrl as generalCampaignUrl } from 'shared/campaign_url'

export function hubPageUrl() {
  return baseUrl(location.hostname, GLOBAL_CONSTS.REQUEST_URI)
}

// returns a url to campaign page with all the arguments filled based on the client's hostname
export function campaignUrl(campaignId, meDomain = false) {
  // don't show .me domain in staging (no support for this)
  const shouldHaveMeDomain =
    meDomain &&
    location.hostname.indexOf('.qa.paypal.com') === -1 &&
    location.hostname.indexOf('.stage.paypal.com') === -1
  return generalCampaignUrl(
    campaignId,
    location.hostname,
    GLOBAL_CONSTS.REQUEST_URI,
    shouldHaveMeDomain
  )
}

export function campaignUrlWithMeDomain(campaignId) {
  return campaignUrl(campaignId, true)
}

// a beautified url helper that drops the https protocol (for display purposes)
export function campaignUrlForDisplay(campaignId) {
  const url = campaignUrl(campaignId, true)
  return url.replace('https://', '')
}
